/* eslint-disable react/forbid-prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { ControlLabel, FormControl, FormGroup, HelpBlock } from 'react-bootstrap';


const nodeOrString = PropTypes.oneOfType([PropTypes.string, PropTypes.node, PropTypes.func]);


const propTypes = {
  label: PropTypes.string,
  componentClass: nodeOrString.isRequired,
  componentProps: PropTypes.object.isRequired,

  input: PropTypes.any,
  meta: PropTypes.any,
};


const defaultProps = {
  input: {},
  label: null,
  meta: { touched: false, error: null, active: false },
};

const BaseInput = (props) => {
  const {
    input,
    meta: { touched, error },
    label,
    componentClass,
    componentProps,
  } = props;
  const validationState = touched ? (error && 'error') : null;
  const showError = touched && error;

  if (!label) {
    return (
      <FormGroup bsSize="small" validationState={validationState}>
        <FormControl {...input} componentClass={componentClass} {...componentProps} />
        <FormControl.Feedback />
        { showError && <HelpBlock>{error}</HelpBlock> }
      </FormGroup>
    );
  }

  return (
    <FormGroup bsSize="small" validationState={validationState}>
      <ControlLabel>{label}</ControlLabel>
      <FormControl {...input} componentClass={componentClass} {...componentProps} />
      <FormControl.Feedback />
      { showError && <HelpBlock>{error}</HelpBlock> }
    </FormGroup>
  );
};


BaseInput.propTypes = propTypes;
BaseInput.defaultProps = defaultProps;

export default BaseInput;
